export const fr = {
  paper: {
    pagination: "Page {current} sur {count}",
    printedOn: "Imprimé le {date} à {time}",
  },
};
